<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Br3QTY/tc-custom/9781250030832.jpg?1733090963580" alt="This image is the cover for the book Stone Roses"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stone Roses
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>The Stone Roses </i>captures the magic—and chaos—behind the UK band's rise, fall, and recent resurrection.</b><br/>The iconic Brit pop band The Stone Roses became an overnight sensation when their 1989 eponymous album went double platinum. It was a recording that is still often listed as one of the best albums ever made. Its chiming guitar riffs, anthemic melodies, and Smiths-like pop sensibility elevated The Stone Roses to a cult-like status in the UK and put them on the map in the U.S. But theirs is a story of unfulfilled success: their star imploded as their sophomore effort took years to complete and the band broke up acrimoniously in 1996. Sixteen years later, they reunited and have been playing sold out gigs, thrilling fans around the globe, and working on new material. In 2013, they nabbed the coveted headline spot at the Coachella Festival. <br/><br/>With one hundred interviews of key figures, forty rare photographs, and exclusive insider material including how they created their music, <i>The Stone Roses </i>charts the band's rise from the backwaters of Manchester to becoming the stars of the "Madchester" scene to their successful comeback years later. Going beyond the myths to depict a band that defined Brit pop, Simon Spence illustrates their incandescent talent and jaw-dropping success while contextualizing them in the 90s music scene. This <i>is</i> the definitive story of The Stone Roses.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Simon Spence
      </h2>
      
      <p class="authorDescription body article">SIMON SPENCE is a writer, journalist, and biographer who has collaborated with Rolling Stones manager Andrew Loog Oldham on the acclaimed memoirs <I>Stoned</I> and <I>2Stoned</I>. He has written for the <I>NME</I>, <I>i-D</I>, <I>Dazed & Confused</I> and the <I>Independent</I>. He lives in London, England.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ff71305